// Top 100 girl and boy names in 2025 in USA
// From https://www.ssa.gov/cgi-bin/popularnames.cgi
// Order has been randomized
export const firstNames = [
  'Lucy',
  'Beau',
  'Eloise',
  'Luca',
  'Sofia',
  'Ian',
  'Ayla',
  'Caroline',
  'Everett',
  'Dylan',
  'Christopher',
  'Nathan',
  'Lydia',
  'Gael',
  'Chloe',
  'Joshua',
  'Emery',
  'Miles',
  'Samuel',
  'Matthew',
  'Abigail',
  'Mila',
  'Nolan',
  'Natalie',
  'Charles',
  'Ailany',
  'Harper',
  'Noah',
  'Caleb',
  'Lillian',
  'Layla',
  'Scarlett',
  'Victoria',
  'Zoe',
  'Josiah',
  'Sienna',
  'Penelope',
  'Naomi',
  'Santiago',
  'Maverick',
  'Liam',
  'Evelyn',
  'Gianna',
  'Weston',
  'Avery',
  'Aria',
  'Adriel',
  'Olivia',
  'Benjamin',
  'Adeline',
  'Addison',
  'Ethan',
  'Leo',
  'Michael',
  'August',
  'Brooks',
  'Myles',
  'Melody',
  'Henry',
  'Oliver',
  'Vivian',
  'Isla',
  'Clara',
  'Hazel',
  'Eithan',
  'Zoey',
  'Sophie',
  'Jack',
  'Luna',
  'Jeremiah',
  'Eleanor',
  'Grace',
  'Silas',
  'Alice',
  'Elias',
  'Juniper',
  'Audrey',
  'Wesley',
  'Emilia',
  'Kennedy',
  'Emiliano',
  'Madelyn',
  'Bennett',
  'Ella',
  'Carter',
  'Adrian',
  'Owen',
  'Ava',
  'Violet',
  'Maya',
  'Aurora',
  'Kai',
  'Isaac',
  'Amara',
  'Leah',
  'Genesis',
  'Atlas',
  'Jacob',
  'Eliana',
  'Daisy',
  'Lucia',
  'Alexander',
  'Liliana',
  'Theo',
  'Christian',
  'Emma',
  'William',
  'Daniel',
  'Micah',
  'James',
  'Robert',
  'Willow',
  'Isabella',
  'Thiago',
  'Hudson',
  'Quinn',
  'Josephine',
  'Wyatt',
  'Julian',
  'Sophia',
  'Lily',
  'Andrew',
  'Leonardo',
  'Mia',
  'Charlotte',
  'Paisley',
  'Amelia',
  'Millie',
  'Elijah',
  'Delilah',
  'Joseph',
  'Josie',
  'Jayden',
  'John',
  'Lincoln',
  'Ellie',
  'Ivy',
  'Logan',
  'Sarah',
  'Madison',
  'Jackson',
  'Grayson',
  'Gabriel',
  'Maeve',
  'Jose',
  'Ruby',
  'Georgia',
  'Cameron',
  'Axel',
  'Stella',
  'Arthur',
  'Maria',
  'Eden',
  'Luka',
  'Cooper',
  'Waylon',
  'Enzo',
  'Jonathan',
  'Autumn',
  'Riley',
  'Valentina',
  'Roman',
  'Everly',
  'David',
  'Archer',
  'Camila',
  'Nora',
  'Aaron',
  'Elena',
  'Levi',
  'Isaiah',
  'Rowan',
  'Asher',
  'Madeline',
  'Lucas',
  'Elizabeth',
  'Iris',
  'Sadie',
  'Nova',
  'Mason',
  'Lainey',
  'Luke',
  'Ryan',
  'Angel',
  'Theodore',
  'Jade',
  'Thomas',
  'Kinsley',
  'Lyla',
  'Hannah',
  'Ezra',
  'Aiden',
  'Leilani',
  'Claire',
  'Emily',
  'Anthony',
  'Mateo',
  'Walker',
  'Ezekiel',
  'Sebastian',
];

// Taken from US Census data last names
// https://www2.census.gov/library/publications/decennial/2020/c2020br-14.pdf
// https://www2.census.gov/topics/genealogy/2020surnames/Names2020_LastNames_RaceHispanic.xlsx
// Order has been randomized.
export const lastNames = [
  'Li',
  'Joseph',
  'Hunt',
  'Davis',
  'Dorsey',
  'Wu',
  'Weiss',
  'Orozco',
  'Young',
  'Schroeder',
  'Mueller',
  'Brown',
  'James',
  'Gaines',
  'Garcia',
  'Perez',
  'Trejo',
  'Wilson',
  'Yoder',
  'Harris',
  'Mohamed',
  'Magana',
  'Martin',
  'Shah',
  'Booker',
  'Klein',
  'Patel',
  'Sanchez',
  'Thomas',
  'Jackson',
  'Moore',
  'Vang',
  'Charles',
  'Juarez',
  'Smith',
  'Xiong',
  'Huang',
  'Vazquez',
  'Allen',
  'Anderson',
  'Jacobs',
  'White',
  'Taylor',
  'Ahmed',
  'Khan',
  'Sampson',
  'Zhu',
  'Hernandez',
  'Schwartz',
  'Lee',
  'Martinez',
  'Mosley',
  'Ramirez',
  'Kaur',
  'Nguyen',
  'Walker',
  'Lowery',
  'Huerta',
  'Velazquez',
  'Zhang',
  'Ware',
  'Wong',
  'Xu',
  'Gonzalez',
  'Lewis',
  'Lucero',
  'Ashley',
  'Banks',
  'Friedman',
  'Ali',
  'Schneider',
  'Pierre',
  'Liu',
  'Avalos',
  'Zavala',
  'Chen',
  'Lin',
  'Jones',
  'Williams',
  'Rodriguez',
  'Washington',
  'Schmitt',
  'Jefferson',
  'John',
  'Moses',
  'Clark',
  'Johnson',
  'Frank',
  'Barajas',
  'Robinson',
  'Thompson',
  'Kruger',
  'Blackwell',
  'Jackson',
  'Singh',
  'Zheng',
  'Zhou',
  'Hall',
  'Miller',
  'Lopez',
  'Zhao',
];

export enum PiiRoles {
  Student = 'student',
}

export enum PiiTypes {
  FirstName = 'FirstName',
  LastName = 'LastName',
  Email = 'Email',
  FullName = 'FullName',
  Other = 'Other',
}

/**
 * The built in random number generators don't allow us to set the seed which we
 * need to keep the output names stable.
 * taken from https://gist.github.com/tommyettinger/46a874533244883189143505d203312c?permalink_comment_id=4854318#gistcomment-4854318
 */
function splitmix32(seed: number): () => number {
  let state;
  return () => (
    (seed = (seed + 0x9e3779b9) | 0), // |0 is an optimization; prevents VM from leaving 32-bit mode via addition
    (state = Math.imul(seed ^ (seed >>> 16), 0x21f0aaad)),
    (state = Math.imul(state ^ (state >>> 15), 0x735a2d97)),
    (state = state ^ (state >>> 15)) & 0xff // truncate to 8 bit number
  );
}

/**
 * This hash function is a polynomial rolling hash function which is commonly
 * used for string search algorithms. It is used here because we need a number
 * to seed the PRNG and the standard WebCrypto digest API returns promises which
 * PostHog's interface won't accept.
 */
function hashName(name: string): number {
  // Prime roughly the size of the input alphabet. Since we are working
  // in JavaScript and all strings are UTF-16, we iterate the string
  // via UTF-16 code units. These are 16 bits long and this is
  // the closest prime to 2 ** 16.
  const p = 65_537;

  // BIG NUMBER to reduce collisions, which isn't needed too much in our
  // scencario but I didn't want to deviate from the examples I was looking at
  // without a reason.
  const modulus = 1e9 + 9;
  let hashValue = 0;
  let pPow = 1; // equal to p^0
  for (let i = 0; i < name.length; i++) {
    const charCode = name.charCodeAt(i);
    // we down't want a letter in our alphabet to map to 0 since
    // that would cause unnecessary collisions.
    hashValue = (hashValue + (charCode + 1) * pPow) % modulus;
    pPow = (pPow * p) % modulus;
  }
  return hashValue;
}

function scaleToRange(input: number, inputMin: number, inputMax: number, targetMin: number, targetMax: number): number {
  const scaledNumber = ((targetMax - targetMin) * (input - inputMin)) / (inputMax - inputMin) + targetMin;
  return Math.round(scaledNumber); // Scaling is continous but we need integers to use as indexes
}
/**
 * Please read the remarks in the function body before using.
 * @param publicUserId Identifies the user the output masks. Should not be PII itself.
 * @param wordList A list of words or names to be selected.
 * @returns A word from wordList chosen by seeding a PRNG with the hash of publicUserId
 */
export function generatePseudonym(publicUserId: string, wordList: string[]): string {
  /*
  What we want is to have a stable input to output mapping that is not
  reversable. Same input name produces the same ouput name everytime but if all
  you have is the output name you can't uniquely identify the input name. At
  best an attacker seeking to unmask the input data given this code and an
  output should only be able to determine a set of possible inputs but not the
  exact input.

  We want it to be like picking a random name from the output list but the same
  input always picks the same random name. A truly random choice is not
  repeatable but PRNGs produce numbers that have similar properties to random
  number but in a deterministic way based on a seed. Usually the seed needs to
  be actually random but we want the mapping to be stable so we use the hash of
  the input as the seed. We don't use the hash to pick the name directly because
  those tend to clump up around the middle of the word list and you don't use
  all of the names. We don't want to ship names that won't get used and the PRNG
  seems to help choose names more evenly.

  The weak link of this masking is the hash function. It's not cryptographically
  secure which makes it easier (not sure how to calculate how easy) for an
  attacker to generate the set of inputs that would produce a given output. With
  access to other information stored with the anonymized name (for example site
  or network name), the attacker could correlate that with roster information or
  perhaps other data obtained from public sources or otherwise and deanonymize
  the student. This approach is also vulnerable to rainbow table attacks.
  Choosing a stronger hash function might make the process take longer but
  wouldn't prevent it from happening.

  For those reasons, we don't use the PII we are masking as the input to select
  a pseudonym. We use the public user id. This id is unique to the student and
  only linked to the PII in our database and authentication provider. If only
  systems with the public user id and pseudonyms generated from the public user
  id are breached, then student PII should not be able to be determined.
  */

  const hash = hashName(publicUserId);
  const nameIndex = scaleToRange(
    splitmix32(hash)(), // Use a PRNG to generate a number based on the hash
    0,
    2 ** 8, // the number will be an 8 bit number
    0,
    wordList.length - 1, // range of possible array indexes
  );
  return wordList[nameIndex];
}
/**
 * Mask text elements sent to an external service.
 * Designed for use with PostHog's maskTextFn
 *
 * @param text Text that would be sent to an external service
 * @param element The element that contains text
 * @returns either text or a replacement string
 */
export function maskTextElement(text: string, element?: HTMLElement) {
  const role = element?.dataset['piiRole'];
  const piiType = element?.dataset['piiType'];
  const publicUserId = element?.dataset['piiPublicUserId'] ?? '';
  if (role === PiiRoles.Student) {
    switch (piiType) {
      case PiiTypes.Email:
        return 'student-email@teachtoone.org';
      case PiiTypes.FirstName:
        return generatePseudonym(publicUserId, firstNames);
      case PiiTypes.LastName:
        return generatePseudonym(publicUserId, lastNames);
      case PiiTypes.FullName:
        return generatePseudonym(publicUserId, firstNames) + ' ' + generatePseudonym(publicUserId, lastNames);
      default:
        return '*'.repeat(text.length);
    }
  }
  return text;
}

/**
 * Mask user entered text to be sent to an external service.
 * Designed for use with PostHog's maskInputFn
 *
 * @param text Text that would be sent to an external service
 * @param element The input element that text was entered in
 * @returns either text or a replacement string
 */
export function maskInputElement(text: string, element?: HTMLElement) {
  const role = element?.dataset['piiRole'];

  // This is the same as element?.attributes['type'].value
  // except TypeScript doesn't hate it.
  const inputType = element?.attributes.getNamedItem('type')?.value;

  if (role === PiiRoles.Student || inputType === 'password') {
    return '*'.repeat(text.length);
  }
  return text;
}
